import { connect } from 'react-redux';
import LaporanGuruBelumSertifikat from '../../../views/Akademi/LaporanIndividual/LaporanGuruBelumSertifikat.view';
import { getParamOptionsAcademics, getPrmLevels } from '../../../states/thunks/options.thunk';
import { listReportGuruBelumSertifikat, getHeadmaster } from '../../../states/thunks/academics.thunk';
function mapStateToProps(state){
    return{
        user: state.user,
        result: state.result,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getParamOptionsAcademics: (payload, type) => dispatch(getParamOptionsAcademics(payload, type)),
        handleListReportGuruBelumSertifikat: (payload) => dispatch(listReportGuruBelumSertifikat(payload)),
        getPrmLevels: (payload) => dispatch(getPrmLevels(payload)),
        getHeadmaster: (payload) => dispatch(getHeadmaster(payload)),

    };
}

export default connect(mapStateToProps, mapDispatchToProps)(LaporanGuruBelumSertifikat);